import { useSelector } from 'react-redux';

/**
 * Hook to get the conversation ID of a Text-From-911 conversation
 * @param {String} callerID - string value of the caller ID
 */
export const useSelectedTextFrom911ConversationID = callerID => {
  const conversationID = useSelector(
    state =>
      state?.textFrom911.conversations?.[callerID]?.data?.conversation_id,
  );

  return conversationID;
};

/**
 * Hook to get the conversation of a Text-From-911 conversation. Includes the
 * loading/error states
 * @param {String} callerID - string value of the caller ID
 */
export const useSelectedTextFrom911Conversation = callerID => {
  const conversation = useSelector(
    state => state?.textFrom911.conversations?.[callerID],
  );
  return conversation;
};
